import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_RUNBOOKS_QUERY_KEY = 'apa-runbooks';

export const getRunbooksQueryKey = () => [APA_RUNBOOKS_QUERY_KEY] as const;

const getRunbooksQueryOptions = ({
  organizationId,
  enabled = true,
}: {
  organizationId?: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getRunbooksQueryKey(),
    queryFn: async () => {
      const { data } = await apiClient.apa.getRunbooks({
        organizationId: organizationId!,
      });
      return data.items || [];
    },
    enabled: enabled && !!organizationId,
  });

export const useRunbooksQuery = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { currentOrganization } = useOrganizations();

  const {
    isLoading,
    data: runbooks,
    error,
    refetch,
  } = useQuery(
    getRunbooksQueryOptions({
      organizationId: currentOrganization?.id,
      enabled,
    })
  );

  return {
    isLoading,
    runbooks,
    error,
    refetch,
  };
};
